import React from 'react';
import { Box, Typography, CircularProgress, Switch } from '@mui/material';

/**
 * Dense toggle aligned with DataGridPro / global storage.
 * Pass values from `useGlobalDenseMode()` in the parent so tables can share the same `denseMode`.
 */
export default function GlobalDenseModeToolbar({
  denseMode,
  denseModeTogglePending,
  persistDenseMode,
  sx = {},
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.25,
        ml: 0.5,
        ...sx,
      }}
      aria-busy={denseModeTogglePending}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          minHeight: 18,
        }}
      >
        <Typography component="span" sx={{ fontSize: '0.8125rem', lineHeight: 1.2 }}>
          Dense mode
        </Typography>
        {denseModeTogglePending && (
          <CircularProgress size={14} thickness={5} aria-label="Applying dense mode" />
        )}
      </Box>
      <Switch
        size="small"
        checked={denseMode}
        disabled={denseModeTogglePending}
        onChange={(e) => {
          if (!persistDenseMode(e.target.checked)) return;
        }}
        inputProps={{ 'aria-label': 'Dense mode' }}
      />
    </Box>
  );
}
